import { MatchEventType } from "../../directus/collections";
import { MatchFilter } from "../../libs/statsFilters";

export interface MaxPosition {
  day: number;
  hour: number;
}
export interface EventsWeeklyHeatMapCell {
  value: number;
  displayValue: string;
  tooltipContent: string;
  isHighlighted: boolean;
  eventDetails: Array<{ matchId: string; targetId: string }>; // ✅ Dettagli eventi per dialog
}
export enum DisplayFormat {
  PERCENTAGE_TOTAL = "percentage_total",
  PERCENTAGE_PARTIAL = "percentage_partial",
  ABSOLUTE = "absolute",
}
export const DAYS_OF_WEEK = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
export interface EventsWeeklyHeatMapWorkerOutput {
  heatmapData: EventsWeeklyHeatMapCell[][];
  maxCount: number;
  activeHours: number[];
  totalMatches: number;
  dayTotals: number[];
  hourTotals: number[];
  maxPosition: MaxPosition | null;
  totalEvents: number;
}
export interface EventsWeeklyHeatMapWorkerInput {
  // data: TimelineEntry[][];
  cityEscapeId?: string;
  enigmaId?: string;
  selectedEventType: MatchEventType;
  trimEmptyHours: boolean;
  displayFormat: DisplayFormat;
  filters?: MatchFilter;
}
